import * as YString from 'yup';
import { code } from '../code';
import { translate } from '../text';

declare module 'yup' {
    interface StringSchema {
        validPhone(phone?: string): this;
        isValidTimeString(time?: string): this;
        maxLength(maxLength: number): this;
    }
}

YString.addMethod(YString.string, 'validPhone', function (errorMessage) {
    if (!errorMessage) errorMessage = 'invalid-phone-number';
    return this.test('validPhone', errorMessage, function (value) {
        if (!value) return false;
        return code.isValidPhoneNumber(value);
    });
});

YString.addMethod(YString.string, 'isValidTimeString', function (errorMessage) {
    if (!errorMessage) errorMessage = 'time-must-be-in-format-HHMM';
    return this.test('isValidTimeString', errorMessage, function (value) {
        if (!value) return false;
        return code.isValidTime(value);
    });
});

YString.addMethod(YString.string, 'maxLength', function (maxLength, errorMessage) {
    if (!errorMessage)
        errorMessage = translate('string-exceeds-maximum-length-of-@maxLength', { maxLength });
    return this.test('maxLength', errorMessage, function (value) {
        if (!value) return false;
        return value.length <= maxLength;
    });
});

export { YString };
